// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetailDropdown_container__3wtIU","item":"OfflineOrderDetailDropdown_item__2A2bv","dropdown-button":"OfflineOrderDetailDropdown_dropdown-button__1lO_r"};